if (!customElements.get('login-modal')) {
  customElements.define(
    'login-modal',
    class LoginModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        $('html').removeClass('overflow-hidden');
      }

      show(opener) {
        super.show(opener);
        $('html').addClass('overflow-hidden');
        this.toggleCustomer();

        const self = this;
        const signInButton = document.getElementById("signInButton");
        const recoverButton = document.getElementById("recoverButton");
        const registerButton = document.getElementById("registerButton");

        signInButton.addEventListener("click", function() {
          const emailField = document.getElementById("CustomerEmail");
          const paswordField = document.getElementById("CustomerPassword");
          self.validateLoginForm(emailField, paswordField);
        });

        recoverButton.addEventListener("click", function() {
          const emailField = document.getElementById("RecoverEmail");
          self.validateRecoverForm(emailField);
        });
        document.getElementById('is_subscribed').addEventListener('change', function() {
        const customerTags = document.getElementById('customer_tags');
        const tag = 'newsletter';
      
        if (this.checked) {
          if (!customerTags.value.includes(tag)) {
            customerTags.value += (customerTags.value ? ',' : '') + tag;
          }
         customerTags.setAttribute('name', 'customer[tags]');

        } else {
          customerTags.value = customerTags.value
            .split(',')
            .filter(item => item !== tag)
            .join(',');
            if (!customerTags.value) {
              customerTags.removeAttribute('name');
            }
        }
      });

        registerButton.addEventListener("click", function() {
          const emailField = document.getElementById("RegisterForm-email");
          const firstNameField = document.getElementById("RegisterForm-FirstName");
          const lastNameField = document.getElementById("RegisterForm-LastName");
          const passwordField = document.getElementById("RegisterForm-password");
          const confirmField = document.getElementById("RegisterForm-confirm-password");
          const tcAgreeCheckbox = document.getElementById("tc-agree-create-account");
          self.validateRegisterForm(emailField, passwordField, firstNameField, lastNameField, confirmField, tcAgreeCheckbox);
        });
      }

      toggleCustomer() {
        var customers = document.querySelectorAll('.customer');
        customers.forEach(function (customer) {
          customer.classList.add('hidden');
        });
        var loginCustomer = document.querySelector('.customer.login');
        if (typeof(loginCustomer) != 'undefined' && loginCustomer != null) {
          loginCustomer.classList.remove('hidden');
        }
        
        var customerLinks = document.querySelectorAll('.customer-link');
        customerLinks.forEach(function (link) {
          link.addEventListener('click', function () {
            var href = link.dataset.href;
      
            customers.forEach(function (customer) {
              customer.classList.add('hidden');
            });
      
            var customerToShow = document.querySelector('.customer.' + href);
            if (customerToShow) {
              customerToShow.classList.remove('hidden');
            }
          });
        });
      }

      validateLoginForm(emailField, paswordField) {
        let isValid = true;

        if (emailField.value.trim() === "") {
          isValid = false;
          emailField.classList.add('error'); 
          this.displayErrorMessage(emailField, true, "It is a required field." );
        } else if(!this.isValidEmail(emailField.value.trim())){
          isValid = false;
          emailField.classList.add('error'); 
          this.displayErrorMessage(emailField, true, "Please enter a valid email address." );
        } else {
          emailField.classList.remove('error'); 
          this.displayErrorMessage(emailField, false);
        }
      
        if (paswordField.value.trim() === "") {
          isValid = false;
          paswordField.classList.add('error'); 
          this.displayErrorMessage(paswordField, true, "It is a required field.");
        } else {
          paswordField.classList.remove('error'); 
          this.displayErrorMessage(paswordField, false);
        }

        if (isValid) {
          this.submitLogin()
        }
      }

      validateRecoverForm(emailField) {
        let isValid = true;

        if (emailField.value.trim() === "") {
          isValid = false;
          emailField.classList.add('error'); 
          this.displayErrorMessage(emailField, true, "It is a required field." );
        } else if(!this.isValidEmail(emailField.value.trim())){
          isValid = false;
          emailField.classList.add('error'); 
          this.displayErrorMessage(emailField, true, "Please enter a valid email address." );
        } else {
          emailField.classList.remove('error'); 
          this.displayErrorMessage(emailField, false);
        }

        if (isValid) {
          this.submitRecover(emailField.value.trim())
          // document.querySelector(".customer.recover form").submit();
        }
      }

      validateRegisterForm(emailField, passwordField, firstNameField, lastNameField, confirmField, tcAgreeCheckbox) {
        let isValid = true;
        var captchaContainer = document.getElementById('re-captcha-modal');

        var captchaError = document.getElementById('captcha-error');
        if (!captchaError) {
            captchaError = document.createElement('div');
            captchaError.id = 'captcha-error';
            captchaError.style.color = '#fc7077';
            captchaError.style.fontSize = '12px';
            captchaContainer.parentNode.insertBefore(captchaError, captchaContainer.nextSibling);
        }
        
        if (firstNameField.value.trim() === "") {
          isValid = false;
          firstNameField.classList.add('error');
          this.displayErrorMessage(firstNameField, true, "It is a required field.");
        } else {
          firstNameField.classList.remove('error');
          this.displayErrorMessage(firstNameField, false);
        }

        if (lastNameField.value.trim() === "") {
          isValid = false;
          lastNameField.classList.add('error'); 
          this.displayErrorMessage(lastNameField, true, "It is a required field.");
        } else {
          lastNameField.classList.remove('error'); 
          this.displayErrorMessage(lastNameField, false);
        }

        if (emailField.value.trim() === "") {
          isValid = false;
          emailField.classList.add('error');
          this.displayErrorMessage(emailField, true, "It is a required field." );
        } else if(!this.isValidEmail(emailField.value.trim())){
          isValid = false;
          emailField.classList.add('error'); 
          this.displayErrorMessage(emailField, true, "Please enter a valid email address." );
        } else {
          emailField.classList.remove('error'); 
          this.displayErrorMessage(emailField, false);
        }

        if (passwordField.value.trim() === "") {
          isValid = false;
          passwordField.classList.add('error'); 
          this.displayErrorMessage(passwordField, true, "It is a required field.");
        } else if(!this.checkPasswordStrength(passwordField)) {
          isValid = false;
          passwordField.classList.add('error'); 
          this.displayErrorMessage(passwordField, true, "Minimum length of this field must be equal or greater than 8 symbols. Leading and trailing spaces will be ignored.");
        } else {
          passwordField.classList.remove('error'); 
          this.displayErrorMessage(passwordField, false);
        }

        if (confirmField.value.trim() === "") {
          isValid = false;
          confirmField.classList.add('error'); 
          this.displayErrorMessage(confirmField, true, "It is a required field.");
        } else if(!this.validatePasswordConfirmation(passwordField, confirmField)) {
          isValid = false;
          confirmField.classList.add('error'); 
          this.displayErrorMessage(confirmField, true, "Please enter the same value again.");
        } else {
          confirmField.classList.remove('error'); 
          this.displayErrorMessage(confirmField, false);
        }

        if (! tcAgreeCheckbox.checked) { 
          isValid = false;
          tcAgreeCheckbox.classList.add('error'); 
          this.displayErrorMessage(tcAgreeCheckbox, true, "It is a required field.");
        } else { // Terms and conditions agreed
          tcAgreeCheckbox.classList.remove('error'); 
          this.displayErrorMessage(tcAgreeCheckbox, false);
        }
       var isCaptchaValid = grecaptcha.getResponse() !== '';

        if (! isCaptchaValid) {
          isValid = false;
          captchaError.textContent = 'It Is A Required Field.';
        } else {
          captchaError.textContent = '';
        }
        if (isValid) {
          // document.getElementById("create_customer").submit();
          this.submitRegister()
        }
      }

      displayErrorMessage(field, display, message = '') {
        const errorMessage = field.parentElement.querySelector('.error-message');
        if (errorMessage) {
          errorMessage.innerHTML = message;
          errorMessage.style.display = display ? 'block' : 'none';
        }
      }

      isValidEmail(email) {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

      validatePasswordConfirmation(passwordInput, confirmPasswordInput) {
        var password = passwordInput.value;
        var confirmPassword = confirmPasswordInput.value;
        return password === confirmPassword;
      }
      checkPasswordStrength(passwordInput) {
        var password = passwordInput.value;
        return password.length >= 8;
      }

      submitLogin() {
        const loginForm = document.getElementById("customer_login");
        const signInButton = document.getElementById('signInButton');
        const createButton = document.getElementById('registerBtn');
        const msgEle = document.querySelector('.customer.login > .message');
        const email = document.querySelector('#CustomerEmail').value;
        // Assuming all validations passed
        const formData = new FormData(loginForm);
        const formAction = loginForm.getAttribute("action");
        const formMethod = loginForm.getAttribute("method");
        // createButton.disabled = true;
        // signInButton.disabled = true;
          
        
        fetch(window.subscriptionEndpoint, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action: 'check-email', email: email })
            }).then(response => {
                if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            }).then(data => {
                const messageElement = document.createElement('div');
                messageElement.id = 'api-response-message';
        
                const errorMessageElement = document.getElementById('error_account-active');
                const errorMessageTitle = document.getElementById('message-error-title');
                const existingMessageElement = document.getElementById('api-response-message');
                if (existingMessageElement) {
                existingMessageElement.remove();
                }
        
                if (data.has_account) {
                  const tags = data.customer.tags;
                if (data.account_activate) {
                    fetch(formAction, {
                      method: formMethod,
                      body: formData,
                      headers: {
                        'Accept': 'application/json'
                      }
                    })
                    .then(response => {
                      // console.log({response});
                      if (response.url.indexOf('/login') === -1) {
                        // console.log('User loggin successfully');
                        if (typeof(msgEle) != 'undefined' && msgEle != null) {
                          msgEle.classList = 'message success';
                          msgEle.innerHTML = "<div>Login successful.</div>";
                        }
                        setTimeout(function() {
                          window.location.reload();
                        }, 500);
                      } else {
                        // console.log('login failed', {msgEle});
                        if (typeof(msgEle) != 'undefined' && msgEle != null) {
                          msgEle.classList = 'message error';
                          msgEle.innerHTML = "<div>Invalid login or password.</div>";
                        }
                        
                        // createButton.disabled = false;
                        // signInButton.disabled = false;
                      }
                    })
                    .catch(error => {
                      console.error('Login Error:', error);
                      if (typeof(msgEle) != 'undefined' && msgEle != null) {
                        msgEle.classList = 'message error';
                        msgEle.innerHTML = "<div>Invalid login or password.</div>";
                      }
                      // createButton.disabled = false;
                      // signInButton.disabled = false;
                    });
                }else if (tags?.includes('newsletter')) {
                    document.querySelectorAll('.form__message.error-message-container').forEach((element) => {
                      element.classList.add('active');
                    });
                    errorMessageTitle.classList.remove('active');
                    messageElement.innerText = `Email does not have an account. Please register.`;
                    errorMessageElement.appendChild(messageElement);
                  } 
                 else {
                    messageElement.innerHTML = window.loginFormStrings.reset_password_message;
                    errorMessageTitle.classList.add('active');
                    errorMessageTitle.innerHTML = data.message_title;
                    errorMessageElement.appendChild(messageElement);
                     document.querySelectorAll('.form__message.error-message-container').forEach((element) => {
                      element.classList.add('active');
                    });
                    document.getElementById('error_account-active').classList.add('activate-message');
        
                    document.getElementById('send-activation-email').addEventListener('click', function(event) {
                    if (!event.detail || event.detail === 1) {
                        event.preventDefault();
                        fetch(window.subscriptionEndpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ action: 'send-activation-email', email: email })
                        }).then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                        }).then(data => {
                          console.log(data.message);
                          alert(window.loginFormStrings.activation_sent);
                        }).catch(error => console.error('Error:', error));
                    }
                    });
                }
                } else {
                console.log("dont have account");
                document.querySelectorAll('.form__message.error-message-container').forEach((element) => {
                  element.classList.add('active');
                });
                errorMessageTitle.classList.remove('active');
                messageElement.innerText = data.message;
                errorMessageElement.appendChild(messageElement);
                errorMessageElement.classList.remove('activate-message');
                }
            }).catch(error => console.error('Error:', error));
      }

      submitRecover(email) {
        const recoverForm = document.querySelector(".customer.recover form");
        const recoverBtn = document.getElementById('recoverButton');
        const msgEle = document.querySelector('.customer.recover > .message');
          
        // Assuming all validations passed
        const formData = new FormData(recoverForm);
        const formAction = recoverForm.getAttribute("action");
        const formMethod = recoverForm.getAttribute("method");
        recoverBtn.disabled = true;
          
        fetch(formAction, {
          method: formMethod,
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => {
          if (typeof(msgEle) != 'undefined' && msgEle != null) {
            msgEle.classList = 'message success';
            const msg = window.loginFormStrings.recover_password_message_success;
            msgEle.innerHTML = msg.replace("[email]", email);
          }
          recoverBtn.disabled = false;
        })
        .catch(error => {
          console.error('Login Error:', error);
          if (typeof(msgEle) != 'undefined' && msgEle != null) {
            msgEle.classList = 'message error';
            msgEle.innerHTML = "<div>something went wrong, try again.</div>";
          }
          recoverBtn.disabled = false;
        });
      }

      submitRegister() {
        var regiterForm = document.getElementById("create_customer");
        var createButton = document.getElementById('registerButton');
        const msgEle = document.querySelector('.customer.register > .message');

        var formData = new FormData(regiterForm);
        var formAction = regiterForm.getAttribute("action");
        var formMethod = regiterForm.getAttribute("method");
        // createButton.disabled = true;
        fetch(formAction, {
          method: formMethod,
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => {
          // console.log(111,response);
          if (response.url.indexOf('/register') === -1) {
            console.log('creates successfully', {msgEle});
            Shopify?.analytics?.publish?.('fbq_complete_registration');
            if (typeof(msgEle) != 'undefined' && msgEle != null) {
              msgEle.classList = 'message success';
              msgEle.innerHTML = "<div>Create an account successfully. Please wait...</div>";
            }
            setTimeout(function() {
              window.location.reload();
            }, 500);
          }
          else if (response.url.includes('/register')) {
            // console.log('creates successfully', {msgEle});
            return response.text().then(bodyText => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(bodyText, 'text/html');

              const formMessageElements = doc.querySelectorAll('.form__message ul li');

              // console.log("Number of .form__message elements:", formMessageElements.length);

              if (formMessageElements.length > 0) {
                // console.log("HTML content of the first .form__message element:", formMessageElements[0].innerHTML);
                const existingErrorMessage = document.getElementById('formMessageError');
                if (typeof(msgEle) != 'undefined' && msgEle != null) {
                  msgEle.classList = 'message error';
                  msgEle.innerHTML = "<div>" + formMessageElements[0].innerHTML + "</div>";
                }
              } else {
                console.log('No form__message elements found.');
              }

            });
          } else {
             console.log('User created fail');
             if (typeof(msgEle) != 'undefined' && msgEle != null) {
              msgEle.classList = 'message error';
              msgEle.innerHTML = "<div>There is already an account with this email address. If you are sure that it is your email address, &lt;a href=&quot;/account/login#recover&quot; class=&quot;txt-und&quot;&gt;click here&lt;/a&gt; to get your password and access your account.</div>";
            }
            // createButton.disabled = false;
          }
        })
        .catch(error => {
          console.error('Created Error:', error);
          if (typeof(msgEle) != 'undefined' && msgEle != null) {
            msgEle.classList = 'message error';
            msgEle.innerHTML = "<div>There is already an account with this email address. If you are sure that it is your email address, &lt;a href=&quot;/account/login#recover&quot; class=&quot;txt-und&quot;&gt;click here&lt;/a&gt; to get your password and access your account.</div>";
          }
          // createButton.disabled = false;
        });
          

      }
    }
  );
}
